<template>
    <div class="card" v-if="question">
        <div class="card-content">
            <div class="media-content">
                <p class="title is-4">{{question.content}}</p>
                <div class="content">
                    <p><strong>Orden: </strong>{{question.order}}</p>
                    <p><strong>Tipo de pregunta: </strong>{{question.type}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Show",
        props: {
            question: Object
        },
        data() {
            return {
                loading: false,
                errors: {},
                ready: false,
            }
        },
        mounted() {
            this.prepareComponent();
        },
        beforeRouteEnter (to, from, next) {
            next(vm => vm.prepareComponent())
        },
        methods: {
            prepareComponent() {
                this.loading = false;
                this.$root.preloader = false;
                this.getQuestion();
            },
            getQuestion() {
                this.ready = false;
                setTimeout(() => {
                    this.ready = true;
                }, 500)
            },
        }
    }
</script>

<style scoped>

</style>